// extracted by mini-css-extract-plugin
export default {"link":"SC-z","disabled":"TC-z"};